import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { SubmitDocumentsConfirmModalComponent } from './submit-documents-confirm-modal.component';

@NgModule({
  imports: [CommonModule, TrackingModule, UiModule],
  declarations: [SubmitDocumentsConfirmModalComponent],
})
export class SubmitDocumentsConfirmModalModule {}
